import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="FAQ"
            title="常见问题"
            desc="关于这个频道怎么运作、内容立场如何把握，这里是几个最常被问到的问题。"
          />
          <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
            <i className="ri-customer-service-2-line text-2xl text-secondary-700"></i>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              还有别的疑问？直接发邮件给我们，通常两个工作日内回复。
            </p>
            <a
              href="mailto:contact@meirichigua.com"
              className="mt-3 inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-secondary-700 hover:text-secondary-800"
            >
              contact@meirichigua.com
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <Reveal key={item.q} delay={index * 50}>
                  <div>
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
                      >
                        <span className="flex items-start gap-3">
                          <span className="mt-0.5 font-heading text-sm font-bold text-primary-500">
                            {String(index + 1).padStart(2, '0')}
                          </span>
                          <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                            {item.q}
                          </span>
                        </span>
                        <i
                          className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} shrink-0 text-lg text-foreground-500`}
                        ></i>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6">
                        <p className="pl-0 text-sm leading-relaxed text-foreground-600 md:pl-8">{item.a}</p>
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}